import React, { FC } from 'react';
import { useItinerary } from '../../Itinerary/Provider';
import { Flex, Glyph, Body, Box } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

export const PriceTendencyMessage: FC<{ trend: 'equal' | 'up' | 'down' }> = ({
  trend,
}) => {
  const { t } = useTranslation();
  const isTrendDown = trend === 'down';
  const backgroundColor = isTrendDown ? 'green.20' : null;
  const backgroundGradient = isTrendDown
    ? ''
    : 'linear-gradient(270deg, rgba(220, 60, 51, 0.20) 0%, rgba(247, 109, 16, 0.20) 100%)';
  const fontColor = isTrendDown ? 'green.90' : 'red.50';
  const titleText = isTrendDown
    ? t('flexibleDates.reprice.low.title')
    : t('flexibleDates.reprice.high.title');
  const subtitleText = isTrendDown
    ? t('flexibleDates.reprice.low.subtitle')
    : t('flexibleDates.reprice.high.subtitle');
  const iconStyle = {
    color: fontColor,
    transform: isTrendDown ? `rotate(-276deg)` : null,
    marginRight: '2x_small',
    marginTop: isTrendDown ? '0' : '2px',
  };
  return (
    <Box
      backgroundColor={backgroundColor}
      sx={{
        margin: '-5px auto 0',
        position: 'relative',
        paddingLeft: '1x_small',
        paddingTop: 'small',
        paddingBottom: '6px',
        zIndex: -1,
        background: backgroundGradient,
        borderBottomRightRadius: '6px',
        borderBottomLeftRadius: '6px',
      }}
      data-testid="price-tendency-box"
    >
      <Flex>
        <Glyph category="Deals" name="TrendingUp" size="small" sx={iconStyle} />
        <Body
          type="small"
          weight="bold"
          color={fontColor}
          sx={{
            marginRight: '2x_small',
          }}
        >
          {titleText}
        </Body>
        <Body type="small" color={fontColor}>
          {subtitleText}
        </Body>
      </Flex>
    </Box>
  );
};

const PriceTendency: FC = () => {
  const { dealInfo } = useItinerary();
  const trend: 'equal' | 'up' | 'down' = dealInfo?.trend;
  return trend && trend !== 'equal' ? (
    <PriceTendencyMessage trend={trend} />
  ) : null;
};

export default PriceTendency;
